// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1tskC","inputWrap":"Table_inputWrap__c6VxF","col":"Table_col__1wfEo","bmiTooltip":"Table_bmiTooltip__3KxXO"};